import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { HotkeyInfo } from './mng-hotkeys.service';
import { MngHotkey } from './mng-hotkeys.types';
import { MatDivider } from '@angular/material/divider';
import { MngHotkeyComponent } from './mng-hotkey/mng-hotkey.component';
import { MatList, MatListItem } from '@angular/material/list';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { MngDialogHeaderComponent } from '../dialog/dialog-header/mng-dialog-header.component';

export interface HotkeysData {
  registeredHotkeys: Map<string, HotkeyInfo>;
}

@Component({
  selector: 'mng-hotkeys-help-dialog',
  imports: [
    MngDialogHeaderComponent,
    MatIconButton,
    MatIcon,
    MatDialogContent,
    MatList,
    MatListItem,
    MngHotkeyComponent,
    MatDivider
  ],
  templateUrl: './mng-hotkeys-help-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager
})
export class MngHotkeysHelpDialogComponent {
  dialogRef = inject<MatDialogRef<MngHotkeysHelpDialogComponent>>(MatDialogRef);
  data = inject<HotkeysData>(MAT_DIALOG_DATA);

  browserHotkeys: MngHotkey[] = [
    { modifier: 'strg', key: '+', description: 'Vergrößern' },
    { modifier: 'strg', key: '-', description: 'Verkleinern' },
    { modifier: 'strg', key: '0', description: 'Standard-Zoom' }
  ];

  get hotkeyList(): MngHotkey[] {
    const hotkeys: MngHotkey[] = [];

    this.data.registeredHotkeys.forEach((entry, key) => {
      const parts = key.split('.');

      if (parts.length === 2) {
        hotkeys.push({ key: parts[1], description: entry.description, modifier: parts[0] });
      }

      if (parts.length === 1) {
        hotkeys.push({ key: parts[0], description: entry.description });
      }
    });

    return hotkeys.sort((hotkey1, hotkey2) => {
      if (!hotkey1.modifier) {
        return -1;
      }
      if (hotkey2.key === 'h') {
        return -1;
      }
      if (hotkey1.key < hotkey2.key) {
        return -1;
      } else {
        return 1;
      }
    });
  }

  close() {
    this.dialogRef.close();
  }
}
